import React from 'react';
import { useField } from 'formik';
import { IFormikFieldProps } from './FormikFieldProps';
import { FormControl, FormControlProps } from 'react-bootstrap';

export type TextAreaProps = IFormikFieldProps &
  React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  FormControlProps & {
    isValidIndicator?: boolean;
  };

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    const [field, { value, touched, error }] = useField(props);
    const { isValidIndicator, ...rest } = props;

    return (
      <FormControl
        as="textarea"
        ref={ref as React.RefObject<HTMLTextAreaElement  & typeof FormControl>} // https://github.com/react-bootstrap/react-bootstrap/issues/3568
        isValid={isValidIndicator && value && touched && !error}
        isInvalid={touched && !!error}
        {...field}
        {...rest}
      />
    );
  },
);
